import React from "react";

import SelectUser from "./SelectUser";
import { useMyTaskUserState } from "../../hooks/useMyTaskUserState";

function User() {
  const { myTaskUser } = useMyTaskUserState();

  return <div>{myTaskUser && <SelectUser user={myTaskUser} />}</div>;
}

export default User;
